import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';
import TaskModal from "./TaskModal";
import TaskModel from "./models/TaskModel";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";

function TaskGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [taskModel, setTaskModel] = useState(new TaskModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    props.fetchTask();
  }

  const rows = props.TaskData
    ? props.TaskData.filter(
      (item) =>
        (item.Title &&
          item.Title.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Description &&
          item.Description.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.TaskKey &&
          item.TaskKey.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.ClientName &&
          item.ClientName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.ClientCompanyName &&
          item.ClientCompanyName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Priority &&
          item.Priority.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.AssignedTo &&
          item.AssignedTo.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Status &&
          item.Status.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setTaskModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const taskModel = data;
    if (e.target.name === "Edit") {
      let taskDetails = {
        TaskId: taskModel.TaskId,
        TitleId: taskModel.TitleId,
        ClientId: taskModel.ClientId ? taskModel.ClientId : null,
        ClientInvestment: null,
        AssignedToUserId: taskModel.AssignedToId,
        PriorityId: taskModel.PriorityId,
        StatusId: taskModel.StatusId,
        Description: taskModel.Description,
        ClientCompanyId: taskModel.ClientCompanyId,
        ReferenceNumber: taskModel.ReferenceNumber,
        UserId: getStorageValues('userId'),
      };
      if (validation(taskDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveTask",
            taskDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchTask();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Error", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if (e.target.name === "Delete") {
      const taskModel = data;
      let taskDetails = {
        TaskId: taskModel.TaskId
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteTask", taskDetails
        );
        if (response.status === 200) {
          CreateAlert("Task deleted successfully!!", "Success", setAlert);
          props.fetchTask();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(TaskDetails) {
    var validation = true;
    if (TaskDetails) {
      if (TaskDetails.TitleId !== null) {
        if (TaskDetails.TitleId.length === 0) {
          CreateAlert("Please select or create title!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please select or create title!!", "Warning", setAlert);
        validation = false;
      }

      if (TaskDetails.AssignedToUserId !== null) {
        if (TaskDetails.AssignedToUserId.length === 0) {
          CreateAlert("Please select assigned to user!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please enter title!!", "Warning", setAlert);
        validation = false;
      }
      if (TaskDetails.PriorityId !== null) {
        if (TaskDetails.PriorityId.length === 0) {
          CreateAlert("Please select priority!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please select priority!!", "Warning", setAlert);
        validation = false;
      }
      if (TaskDetails.StatusId !== null) {
        if (TaskDetails.StatusId.length === 0) {
          CreateAlert("Please select status!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please select status!!", "Warning", setAlert);
        validation = false;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const columns = [
    {
      name: <div className="titlename"><span>Key </span></div>,
      selector: row => row.TaskKey,
      cell: (row) => (
        <span title={row.TaskKey}>{row.TaskKey}</span>
      ),
      sortFunction: (rowA, rowB) => {
        const numA = parseInt(rowA.TaskKey.split('-')[1], 10);
        const numB = parseInt(rowB.TaskKey.split('-')[1], 10);
        return numA - numB;
      },
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Title </span></div>,
      selector: row => row.Title,
      cell: (row) => (
        <span title={row.Title}>{row.Title}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Client Name </span></div>,
      selector: row => row.ClientName,
      cell: (row) => (
        <span title={row.ClientName}>{row.ClientName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Client Company </span></div>,
      selector: row => row.ClientCompanyName,
      cell: (row) => (
        <span title={row.ClientCompanyName}>{row.ClientCompanyName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Priority </span></div>,
      selector: row => row.Priority,
      cell: (row) => (
        <span title={row.Priority}>{row.Priority}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Assigned To </span></div>,
      selector: row => row.AssignedTo,
      cell: (row) => (
        <span title={row.AssignedTo}>{row.AssignedTo}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Status </span></div>,
      selector: row => row.Status,
      cell: (row) => (
        <span title={row.Status}>{row.Status}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },]
  if (props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action" >
          {props.UserPermissions.AddModule === 1 ?
          <Link
            className="me-2 p-2"
            to=""
            onClick={() => {
              openActionType(row, "View");
            }}
            title="View"
          >
            <Icons.Eye data-feather="eye" className="action-eye" />
          </Link>
          :null
    }
    {
          props.UserPermissions.EditModule === 1 ?
          <Link
            className="me-2 p-2"
            to=""
            onClick={() => {
              openActionType(row, "Edit");
            }}
            title="Edit"
          >
            <Icons.Edit data-feather="edit" className="feather-edit" />
          </Link>
          :null
    }
    {
          props.UserPermissions.DeleteModule === 1 ? 
          <Link
            className="confirm-text p-2"
            to=""
            onClick={() => {
              openActionType(row, "Delete");
            }}
          >
            <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
          </Link>
          :null
    }
        </div>
      ),
      center: "true",
      width: "150px"
    },);
  }

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="TaskName"
            sortIcon={<SortArrow />}
            persistTableHead={true}
          />
        </div>
      </div>
      <TaskModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={taskModel}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default TaskGrid;
